export type Trail = {
  name: string;
  link: {
    desc: string;
    url: string;
  }
  order: number;
  places: string[];
  trailset: string;
}

// Place type of mark
export type TrailPlace = {
  name: string;
  km: number;
  distances?: number[]
}

export type TrailsPlaces = {
  [placeName: string]: TrailPlace[]
}

export const emptyPlace: Place = {
  id: "",
  name: "",
  address: [],
  capacity: 0,
  phoneNumber: "",
  email: "",
  checkin: "",
  checkout: "",
  details: "",
  detailsPrivate: "",
  distances: [],
  facilities: [],
  hidden: false,
  price: 0,
  trails: [],
  trailsDistances: [],
  type: "",
  ico: "",
  uid: "",
  web: ""
}

export type Place = {
  id: string
  name: string
  mark?: boolean
  address: (string | number)[]
  capacity: number
  phoneNumber?: string
  email?: string
  checkin?: string
  checkout?: string
  details?: string
  detailsPrivate?: string
  distance?: number
  distances?: number[]
  facilities?: string[]
  hidden?: boolean
  price?: number
  trails?: string[] // ["vychodoceska_trasa", "jihoceska_trasa"]
  trailsDistances?: number[]
  type?: string
  ico?: string
  uid?: string
  web?: string
  images?: string[]
}

export const accomodationTypes = [
  { textId: "private", title: "V soukromí" },
  { textId: "rectory", title: "Fara" },
  { textId: "commercial", title: "Komerční ubytování" },
  { textId: "camping", title: "Zahrada/stan" },
  { textId: "other", title: "Jiné" },
]

export type AccomodationTypes = typeof accomodationTypes

interface Position {
  lon: number;
  lat: number;
}

interface RegionalStructureItem {
  name: string;
  type: string;
  isoCode?: string;
}

interface Item {
  name: string;
  label: string;
  position: Position;
  type: string;
  location: string;
  regionalStructure: RegionalStructureItem[];
  zip: string;
  bbox: [number, number, number, number];
}

type LocalityItem = Record<string, string>;

export interface MapyApiResponse {
  items: Item[];
  locality: LocalityItem[];
}

export type UserDetail = {
  displayName: string;
  email: string | null;
  emailVerified: boolean;
  phoneNumber?: string | null;
  photoURL?: string;
  role?: "admin";
}